/**
 * @generated SignedSource<<50f7c6e92a6ec1967aedd8a0b41e2c6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditorTranslateButton_textBlock$data = {
  readonly data: string | null;
  readonly id: string;
  readonly " $fragmentType": "EditorTranslateButton_textBlock";
};
export type EditorTranslateButton_textBlock$key = {
  readonly " $data"?: EditorTranslateButton_textBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_textBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorTranslateButton_textBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "type": "TextBlock",
  "abstractKey": null
};

(node as any).hash = "768db96568787bc0e6556a56ffecdc57";

export default node;
